import React, {Component} from 'react';
import {connect} from 'react-redux';
import AddOrgUserForm from './addOrgUserForm';
import {mapValuesToBody} from './utils';
import {
  retrieveRolesFromPermissions,
  retrieveAllEntityIdsFromPermissions,
} from 'common/utils';
import {createEntityOptions, createRoleOptions} from './utils';
import {ROLE_MAP, ENTITY_MAP} from 'app-ui-componentlibrary/dist/common/constants';
import REST from 'go/requests/rest';

class OrgUserFormContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      error: null,
      orgs: [{}],
    };
  }

  createUser = async (values) => {
    let body = mapValuesToBody(values, this.props.entities);
    return REST.user.addRole(this.props.token, body);
  };

  getEntityType = (permissions, action) => {
    if (action === 'addAnalytics') {
      return ENTITY_MAP.REPORT_CATEGORY.code;
    }
    let entityTypeIds = retrieveAllEntityIdsFromPermissions(permissions);
    if (entityTypeIds == '') {
      return null;
    }
    return entityTypeIds.filter(
      (entityTypeId) => entityTypeId !== ENTITY_MAP.REPORT_CATEGORY.code
    )[0];
  };

  render() {
    const {permissions, mapping} = this.props;

    const ENTITY_ARR = createEntityOptions(this.props.entities);
    let rolesFromPermissions = retrieveRolesFromPermissions(permissions);
    //Remove Analytics Admin
    let ROLES = rolesFromPermissions.filter(
      (role) => role != ROLE_MAP.ANALYTICSADMIN.code
    );
    if (this.props.action === 'addAnalytics') {
      ROLES = [ROLE_MAP.ANALYTICSADMIN.code];
    }
    let ROLES_ARR = createRoleOptions(this.props.mapping, ROLES);
    const entityTypeId = this.getEntityType(permissions, this.props.action);

    return (
      <AddOrgUserForm
        entityId={entityTypeId}
        roles={ROLES}
        users={this.props.userData}
        toggleModal={this.props.toggleModal}
        addModalVisible={this.props.addModalVisible}
        action={this.props.action}
        createUser={this.createUser}
        reloadUserList={this.props.reloadUserList}
        loading={this.state.loading}
        entity_opts={ENTITY_ARR}
        role_opts={ROLES_ARR}
        toggles={this.props.toggles}
      />
    );
  }
}

export const mapStateToProps = (state, ownProps) => {
  return {
    permissions: state.auth.permissions,
    userId: state.auth.userId,
    toggles: state.toggles.toggles,
  };
};

export const connector = connect(mapStateToProps, null);

export default connector(OrgUserFormContainer);
